import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

// menu item imports
import { addApplianceMenuItem } from '../menu-item/add-appliance-menu-item';
import { addCustomApplianceMenuItem } from '../menu-item/add-custom-appliance-menu-item';
import { addCutoutMenuItem } from '../menu-item/add-cutout-menu-item';
import { addSpacerMenuItem } from '../menu-item/add-spacer-menu-item';
import { deleteGroupingMenuItem } from '../menu-item/delete-grouping-menu-item';
import { distributeVerticallyMenuItem } from '../menu-item/distribute-vertically-menu-item';
import { downloadDxfMenuItem } from '../menu-item/download-dxf-menu-item';
import { islandPropertiesMenuItem } from '../menu-item/island-properties-menu-item';
import { lockPositionMenuItem } from '../menu-item/lock-position-menu-item';
import { toggleGroupingCenterlineDimensionMenuItem } from '../menu-item/toggle-grouping-centerline-dimension-menu-item';
import { distributeGroupsHorizonticallyMenuItem } from '../menu-item/distribute-groups-horizontally-menu-item';

export const applianceGroupMenuList: Array<ContextMenuList> = [
	addApplianceMenuItem(),
	addCustomApplianceMenuItem(),
	addCutoutMenuItem(),
	addSpacerMenuItem(),
	distributeVerticallyMenuItem(),
	deleteGroupingMenuItem(),
	lockPositionMenuItem(),
	toggleGroupingCenterlineDimensionMenuItem(),
	distributeGroupsHorizonticallyMenuItem(),

	downloadDxfMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	islandPropertiesMenuItem()
];
